const dataBridal = {
  title: 'Detalii Buchete de Mireasă',
  description: [
    'Fiecare nuntă are o temă și un stil în toate culorile fierbinți! Care este viziunea voastră?',
    'Veniți la noi să discutăm împreună despre buchetul miresei! Va fi compus din florile sau din culorile preferate, vom confecționa manual buchetul la care visați.',
    'Avem flori superbe pentru nunta voastră! Programați o întâlnire cu noi pentru a găsi florile potrivite.',
  ],
  footerNotes: '<p>Așteptăm apelul dvs. la numărul de telefon <a href=\'tel:\'>+373 676 17 827</a> pentru a discuta mai multe detalii.</p>'
};

export default dataBridal;
